function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IsearchHeader = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5625 27.6688L25.3312 21.4375C25.05 21.1562 24.6687 21 24.2687 21H23.25C24.975 18.7938 26 16.0187 26 13C26 5.81875 20.1813 0 13 0C5.81875 0 0 5.81875 0 13C0 20.1813 5.81875 26 13 26C16.0187 26 18.7938 24.975 21 23.25V24.2687C21 24.6687 21.1562 25.05 21.4375 25.3312L27.6688 31.5625C28.2563 32.15 29.2063 32.15 29.7875 31.5625L31.5562 29.7938C32.1437 29.2063 32.1438 28.2563 31.5625 27.6688ZM13 21C8.58125 21 5 17.425 5 13C5 8.58125 8.575 5 13 5C17.4187 5 21 8.575 21 13C21 17.4187 17.425 21 13 21Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    fill: "white"
  }))));
});